import styled from 'styled-components';

const ReaderWrapper = styled.div`
  height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr;

  margin-top: -15px;
  width: 100%;
  font-size: ${props => (props.fontSize ? props.fontSize : 1)}em;

  @media (max-width: 767px) {
    &[data-br-protected-reader='true'] {
      -webkit-touch-callout: none;
    }
  }

  @media print {
    &[data-br-protected-reader='true'] {
      display: none !important;
    }
  }
`;

export default ReaderWrapper;
